import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { API_BASE_URL } from 'constants/index'
import ModalAddress from 'components/Modal/ModalAddress'
import ModalDelete from 'components/Modal/ModalDelete'
import TableBase from 'components/Table/TableBase'
import { convertAddress, formatDateToUnderscore } from 'helpers'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { customerService } from 'services'
import styled from 'styled-components'
import ActionGroup from './ActionGroup'
import { Input, Typography, Alert } from 'antd'
import fetchHelper, { getAuthToken } from 'helpers/FetchHelper'
import FullscreenLoader from 'components/Loading/FullscreenLoader'
import axios from 'axios'
import type { RcFile, UploadRequestOption } from 'rc-upload/lib/interface';
const { Text } = Typography;
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  .ant-table thead tr th {
    background: #fff;
    color: rgba(0, 0, 0, 0.85);
  }
`

const OptionAction = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
  justify-content: center;

  svg {
    cursor: pointer;
  }
`

type TDeliveryTable = {
  type: string
}

const DeliveryTable = ({ type }: TDeliveryTable) => {
  const token = getAuthToken();
  const [dataList, setDataList] = useState<any>([])
  const [dataListFilter, setDataListFilter] = useState<any>([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isModalDelete, setIsModalDelete] = useState(false)
  const [editData, setEditData] = useState<any>(undefined)
  const [loading, setLoading] = useState(false)
  const [messageDeliveryError, setMessageDeliveryError] = useState<string>("")
  const [messageShippingError, setMessageShippingError] = useState<string>("")

  const [searchName, setSearchName] = useState<string>()
  const [searchPhone, setSearchPhone] = useState<string>()

  useEffect(() => {
    if (dataList) {
      let filteredList = [...dataList]

      if (searchName) {
        filteredList = filteredList.filter((item) => item?.full_name?.toLowerCase()?.includes(searchName.toLowerCase()))
      }

      if (searchPhone) {
        filteredList = filteredList.filter((item) => item?.phone_number?.includes(searchPhone))
      }

      setDataListFilter(filteredList)
    }
  }, [dataList, searchName, searchPhone])

  const handleShowModal = () => {
    setIsModalOpen((prev) => !prev)
  }

  const handleShowModalDelete = () => {
    setIsModalDelete((prev) => !prev)
  }

  const handleExport = async () => {
    try {
      setLoading(true);
      const response: any = await fetch(`${API_BASE_URL}/customer-address/export-address?type=${type}`, {
        method: 'GET',
        headers: {
          Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          Authorization: `Bearer ${token}`,
        },
      })
      let name = `danh-sach-nguoi-nhan-${formatDateToUnderscore(new Date())}.xlsx`;
      if (type == "delivery") {
        name = `danh-sach-nguoi-gui-${formatDateToUnderscore(new Date())}.xlsx`;
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
      link.remove();
      setLoading(false)
    } catch (error) {
      console.error("Download failed", error);
      setLoading(false)
    }
  }
  const handleCloseModal = () => {
    if (editData) setEditData(undefined)
    if (isModalOpen) handleShowModal()
    if (isModalDelete) handleShowModalDelete()
  }
  const handleImport = async (options: UploadRequestOption<any>) => {
    const { file, onSuccess, onError } = options;
    setLoading(true)
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', type);

    try {
      const response = await axios.post(`${API_BASE_URL}/customer-address/import-address`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      })
      fetchHelper.addDefaultHeader('Content-Type', 'application/json')
      if (response?.data?.error) {
        toast.error(response?.data?.message)
      } else {
        if (response?.data?.data?.errors != "") {
          if (type == 'delivery') {
            setMessageDeliveryError(response?.data?.data?.errors)
          } else {
            setMessageShippingError(response?.data?.data?.errors)
          }
        }
        customerService.getListAddress(type, (res) => setDataList(res?.addresses))
      }
      setLoading(false)
      onSuccess?.(response.data);
    } catch (err: any) {
      setLoading(false)
      onError?.(err);
    }
  };
  const handleEdit = (item, modalType) => {
    setEditData(item)
    if (modalType === 'edit') handleShowModal()
    if (modalType === 'delete') handleShowModalDelete()
  }
  const onClose = (i) => {
    setMessageDeliveryError("")
    setMessageShippingError("")
  }

  const handleSubmitDelete = async () => {
    if (editData) {
      setLoading(true)

      try {
        await customerService.deleteAddress(
          editData?.id,
          async (response) => {
            setLoading(false)
            handleCloseModal()
            await customerService.getListAddress(type, (res) => setDataList(res?.addresses))
          },
          (response) => {
            toast.error(response?.message || 'Xóa dữ liệu không thành công')
            setLoading(false)
          }
        )
      } catch (error) {
        setLoading(false)
        console.error('deleteAddress', error)
      }
    }
  }

  const columns = [
    {
      title: <Input type='text' placeholder='Tên' value={searchName} onChange={(e) => setSearchName(e?.target?.value)} />,
      dataIndex: 'full_name',
      render: (value) => value,
    },
    {
      title: (
        <Input type='text' placeholder='Điện thoại' value={searchPhone} onChange={(e) => setSearchPhone(e?.target?.value)} />
      ),
      dataIndex: 'phone_number',
      width: '15%',
      render: (value) => value,
    },
    {
      title: 'Địa chỉ',
      dataIndex: 'address',
      width: '45%',
      render: (_, record) => convertAddress(record),
    },
    {
      title: 'Thao tác',
      dataIndex: '',
      width: '15%',
      render: (_, record) => (
        <OptionAction>
          <EditOutlined onClick={() => handleEdit(record, 'edit')} />
          <DeleteOutlined onClick={() => handleEdit(record, 'delete')} />
        </OptionAction>
      ),
    },
  ]

  useEffect(() => {
    customerService.getListAddress(type, (res) => setDataList(res?.addresses))
  }, [type])

  return (
    <>
      {loading && <FullscreenLoader />}
      <Wrapper>
        <ActionGroup onAdd={handleShowModal} onExport={handleExport} onImport={handleImport} />
        {type === "delivery" && messageDeliveryError != "" && (
          <Alert
            description={"Các địa chỉ bị lỗi là: " + messageDeliveryError}
            type="error"
            closable
            onClose={onClose}

          />
        )}
        {type === "shipping" && messageShippingError != "" && (
          <Alert
            description={"Các địa chỉ bị lỗi là: " + messageShippingError}
            type="error"
            closable
            onClose={onClose}

          />
        )}

        <TableBase
          columns={columns}
          dataSource={dataListFilter}
          pagination={false}
          scroll={{ x: 800 }}
          rowKey={(row) => row.id}
        />
      </Wrapper>

      <ModalAddress open={isModalOpen} onCancel={handleCloseModal} type={type} editData={editData} refreshData={setDataList} />
      <ModalDelete
        open={isModalDelete}
        onCancel={handleCloseModal}
        onSubmit={handleSubmitDelete}
        loading={loading}
        title='Xóa địa chỉ'
      />
    </>
  )
}

export default DeliveryTable
